import { COMPLETIONS_FILTERS } from "@pathwright/features/src/modules/completion/utils"
import { COMPLETION_FILTERS as INBOX_COMPLETIONS_FILTERS } from "@pathwright/features/src/modules/inbox/context/completion-filters"
import pick from "lodash/pick"
import { encodeURLParams } from "../lib/core/api/urls"

const COMPLETION_QUERY_PARAMS_MAP = {
  userId: "user_id", // Scope completion items to a user
  cohortId: "cohort_id", // Scope completion items to a cohort
  sourceId: "source_id", // Scope completion items to a source step
  parentId: "parent_id" // scope completion items to a parent group
}

const getCompletionID = () => {
  let completionId = null
  const match = window.location.pathname.match(/completion\/(\d+)\//)
  if (match) {
    completionId = parseInt(match[1])
  }
  return completionId
}

const getExpectedCompletionQueryFilters = () => {
  const params = new URLSearchParams(window.location.search)
  // map the search params to the completion filter key
  const expectedCompletionQueryFilters = Object.entries(
    COMPLETION_QUERY_PARAMS_MAP
  ).reduce((acc, [propKey, paramKey]) => {
    paramKey = parseInt(params.get(paramKey))
    if (paramKey) acc[propKey] = paramKey
    return acc
  }, {})

  return expectedCompletionQueryFilters
}

// Get query args from query params
const getCompletionQueryFilters = () => {
  const params = new URLSearchParams(window.location.search)

  return {
    ...getExpectedCompletionQueryFilters(),
    selectedId: getCompletionID(), // Highlight completion item when panel is open
    filter: params.get("filter") // scope completion items to a parent group
  }
}

const inboxRedirect = (nextState, replace, callback) => {
  const { query } = nextState.location

  const completionContext = {
    ...getCompletionQueryFilters(),
    responseId: parseInt(query.response_id)
  }

  const inboxConversion = {
    userId: (v) => ({ user_id: v }),
    cohortId: (v) => ({ cohort_id: v }),
    sourceId: (v) => ({ source_id: v }),
    parentId: (v) => ({ parent_id: v }),
    // NOTE: step_id forces Inbox to be opend in single item mode since
    // it scopes the data to that single item.
    selectedId: (v) => ({ step_id: v, ui_selected: v }),
    responseId: (v) => ({ ui_panel_selected: v, ui_panel: "discuss" }),
    filter: (v) => {
      // prettier-ignore
      const filterConversion = {
        [COMPLETIONS_FILTERS.NEEDS_REVIEW]: INBOX_COMPLETIONS_FILTERS.pending.key,
        [COMPLETIONS_FILTERS.REVIEWED]: INBOX_COMPLETIONS_FILTERS.reviewed.key,
        [COMPLETIONS_FILTERS.COMPLETE]: INBOX_COMPLETIONS_FILTERS.complete.key,
        [COMPLETIONS_FILTERS.INCOMPLETE]: INBOX_COMPLETIONS_FILTERS.incomplete.key,
        [COMPLETIONS_FILTERS.ALL]: INBOX_COMPLETIONS_FILTERS.all.key
      }

      return {
        filter: filterConversion[v]
      }
    }
  }

  // Preserve any inbox-specific query params that may be present.
  // This could be due to parsing a notificaiton url and appending
  // inbox-specific query params (i.e. for ask-to-answer feedback discussion).
  const baseInboxParams = pick(query, ["ui_panel"])

  // Convert to inbox params.
  const inboxParams = Object.entries(completionContext).reduce(
    (acc, [k, v]) =>
      v && inboxConversion[k]
        ? {
            ...acc,
            ...inboxConversion[k](v)
          }
        : acc,
    baseInboxParams
  )

  // Default to "all" filter.
  if (!inboxParams.filter) {
    inboxParams.filter = INBOX_COMPLETIONS_FILTERS.all.key
  }

  const redirectRoute = replace({
    pathname: "/inbox/",
    search: encodeURLParams(inboxParams)
  })

  // Callback is necessary to delay navigation-store from responding
  // to the current route which we are redirecting from.
  return callback(redirectRoute)
}

const completionRedirectRoute = {
  path: "/completion/:pathItemId?/",
  onEnter: inboxRedirect
}

export default completionRedirectRoute
